function VideoPlayButton() {

    return (
        <svg version="1.1" viewBox="0 0 90 90">
        <g style={{stroke: "none"}}>
            <path style={{stroke: "none", fill: "white"}}
                d="M 45 0 C 20.147 0 0 20.147 0 45 c 0 24.853 20.147 45 45 45 s 45 -20.147 45 -45 C 90 20.147 69.853 0 45 0 z M 62.042 46.604 L 37.288 65.53 c -1.329 1.016 -3.246 0.068 -3.246 -1.604 V 26.074 c 0 -1.673 1.917 -2.62 3.246 -1.604 l 24.754 18.926 C 63.099 44.204 63.099 45.796 62.042 46.604 z" />
        </g>
        </svg>
    )

}

export default VideoPlayButton;